import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { MapPin } from 'lucide-react';

import Thumbnail from 'components/Thumbnails/Thumbnail';

import styles from './DashboardHero.module.scss';

/**
 * Hero section for the Client ATS Dashboard. Shows a welcome message,
 * user avatar, company and location on a blue gradient background.
 */
const DashboardHero = ({ className }) => {
  const user = useSelector((state) => state.auth?.user);

  const displayName =
    user?.displayname.trim() && user?.displayname !== user?.username;
  const company = user?.organisation || false;
  const locationText = user?.location?.text.trim() || '';

  const welcomeText =
    company || !displayName ? 'Welcome Back!' : `Welcome back, ${displayName}!`;

  return (
    <section
      className={`${styles.hero} ${className || ''}`}
      aria-label="Welcome"
    >
      <div className={styles.content}>
        <div className={styles.avatarWrapper}>
          <Thumbnail
            thumbnails={user.avatars}
            className={styles.avatar}
            circle
          />
        </div>
        <div className={styles.textBlock}>
          <h1 className={styles.welcomeText}>{welcomeText}</h1>
          <div className={styles.metaLine}>
            {company && displayName && (
              <span className={styles.company}>{displayName}</span>
            )}
            {company && displayName && locationText && (
              <span className={styles.separator}>•</span>
            )}
            {locationText && (
              <span className={styles.location}>
                <MapPin
                  width={14}
                  height={14}
                  className={styles.locationIcon}
                  aria-hidden="true"
                />
                {locationText}
              </span>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

DashboardHero.propTypes = {
  className: PropTypes.string,
};

DashboardHero.defaultProps = {
  className: '',
};

export default DashboardHero;
